export default {
    "Select partner": "Partner",
    Partner: "Partner",
    Package: "Package",
    "Select group": "Group",
    "Add group": "Add group",
    "Select program": "Program",
    "Select module": "Module",
    "In full screen": "In full screen",
    "Lessons / Homework": "Lessons / Homework",
    Students: "Students",
    "Average score": "Average score",
    Absence: "Absence",
    Classwork: "Classwork",
    Homework: "Homework",
    "Finished Lessons": "Finished Lessons",
    "Ratings, comments": "Ratings, comments",
    Presence: "Presence",
    Close: "Close",
    "Next page >>": "Next page >>",
    "<< Previous page": "<< Previous page",
    "transfer to another class or withdraw from the class?":
        "transfer to another class or withdraw from the class?",
    "Transfer to another class": "Transfer to another class",
    "transfer to another class": "transfer to another class",
    "Select a class": "Select a class",
    Transfer: "Transfer",
    Exclude: "Exclude",
    "student from the class": "student from the class",
    "Are you sure about the student deduction?":
        "Are you sure about the student deduction?",
    "Set new schedule": "Set new schedule",
    "Time start for all lessons": "Time start for all lessons",
    "Time end for all lessons": "Time end for all lessons",
    Timetable: "Timetable",
    "Lesson type for ": "Lesson type for ",
    "Exclude dates": "Exclude dates",
    "Education start": "Education start",
    "Teacher for ": "Teacher for ",
    "Add new program": "Add new program",
    "Remove program": "Remove program",
    Reject: "Reject",
    "The reason for the rejection of the file":
        "The reason for the rejection of the file",
    Cancel: "Cancel",
    Rejected: "Rejected",
    "New file": "New File",
    "Download file": "Download File",
    "Rejected file": "Rejected File",
    "Average score (Classwork)": "Average score (Classwork)",
    "Average score (Homework)": "Average score (Homework)",
    "Final Grade": "Final Grade",
    "Check the task": "Check the task",
};
